import { Box, Container, Grid, Typography } from "@mui/material";
import { Footer } from "../../components/Footer";
import { Navbar } from "../../components/Navbar";
import { Products } from "../../components/Products";
import { Qualifiers } from "../../components/Qualifiers";
import { navItems } from "../navItems";
import useQualifierContext from "../../../../context/qualifiers/hooks/useQualifierContext";

const Home = () => {
	const {
		state: {
			service: {
				name,
				logoUrl,
				bannerImage,
				colorPrimary,
				colorSecondary,
			},
		},
	} = useQualifierContext();

	const fontFamily = "Roboto, Helvetica Neue, Helvetica, Arial, sans-serif";
	const colorWhite = "var(--color-white)";
	const colorBlack = "var(--color-black)";

	return (
		<>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					minHeight: "100vh",
				}}
			>
				<Grid
					container
					columns={12}
					sx={{ fontFamily, maxWidth: "80%", mx: "auto" }}
				>
					<Grid item lg={12} md={12} sm={12} xs={12}>
						{logoUrl && (
							<Navbar
								navItems={navItems}
								backgroundColor={colorWhite}
								color={colorBlack}
								hamburgerColor={colorPrimary}
								logoUrl={logoUrl}
								service={name}
							/>
						)}
					</Grid>
					<Grid
						item
						lg={12}
						md={12}
						sm={12}
						xs={12}
						sx={{
							backgroundImage: bannerImage,
							backgroundRepeat: "no-repeat",
							backgroundSize: "cover",
							backgroundPosition: "center 51%",
							mx: "auto",
							height: 250,
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						<Container sx={{ textAlign: "center", backgroundColor: "rgba(0,0,0,0.5)", py: 3 }}>
							<Typography
								variant="h5"
								fontWeight="bold"
								textTransform="uppercase"
								color="white"
							>
								Required Training for LaScala Restaurant Group Associates
							</Typography>
							<Typography variant="h6" paddingTop={'1em'} color="white" fontWeight="bold">
								Register. Complete Your Training.
								Download Your Certificate.
							</Typography>
						</Container>
					</Grid>
					<Grid
						item
						lg={12}
						md={12}
						sm={12}
						xs={12}
						sx={{
							minHeight: "40vh",
							mx: "auto",
						}}
					>
						<Grid container columns={12}>
							<Grid
								item
								lg={8}
								md={8}
								sm={10}
								xs={11}
								sx={{
									mx: "auto",
									my: "30px",
									backgroundColor: "rgba(255,255,255,0.9)",
									padding: "20px",
									borderRadius: "10px",
								}}
							>
								<Qualifiers />
								<Products
									primaryColor={colorPrimary ?? ""}
									secondaryColor={colorSecondary ?? ""}
									purchaseButtonName={"Register now"}
									productMappingType={2}
								/>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				<Box sx={{ marginTop: "auto" }}>
					<Footer backgroundColor={colorWhite} color={colorBlack} />
				</Box>
			</Box>
		</>
	);
};

export default Home;
